import { PermissionsEnum } from '@/auth/interfaces';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { hasAllPermissions, hasPermission, texto } from '@/shared/utils';
import { useUserPermissionsStore } from '@/store/auth';
import { useUiStore } from '@/store/ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useCheckPermissions = (permision: PermissionsEnum) => {
  const navigate = useNavigate();
  const setAlert = useUiStore(s => s.setAlert);
  const isHydrated = useUserPermissionsStore(s => s.isHydrated);
  // const logOut = useAuthStore(s => s.logout);

  useEffect(() => {
    if (!isHydrated) return;
    if (!hasPermission(permision)) {
      setAlert(true, texto.acceso_denegado_403, AlertSeverityEnum.error);
      navigate('/', { replace: true });
      // logOut();
    }
  }, [isHydrated]);
};

export const useCheckPermissionsArray = (permissions: PermissionsEnum[]) => {
  const navigate = useNavigate();
  const setAlert = useUiStore(s => s.setAlert);
  const isHydrated = useUserPermissionsStore(s => s.isHydrated);

  useEffect(() => {
    if (!isHydrated) return; 
    if (!hasAllPermissions(permissions)) {
      setAlert(true, texto.acceso_denegado_403, AlertSeverityEnum.error);
      navigate('/', { replace: true });
    }
  }, [isHydrated]);
};
